<template>
  <div
    class="flex h-[41px] cursor-pointer select-none items-center gap-[11px]
    px-[15px] text-[14px] text-[--v3-theme-primarytextcolor]
    transition-all duration-150 hover:bg-[--v3-theme-primarydarkestcolor]
    hover:text-[--v3-theme-primarytextcolor] active:bg-[--v3-theme-primarydarkercolor]
    "
    :class="{
      'bg-[--v3-theme-primarydarkercolor]': shop.id === currentShopId,
      'bg-[--v3-theme-primarydarkcolor]': shop.id !== currentShopId
    }"
  >
    <span class="shop-name notranslate" translate="no">{{ shop.name }}</span>
    <div
      class="block size-2 rounded-full"
    />
  </div>
</template>

<script setup lang='ts'>
import { useAuthStore } from '@/common/stores/auth';
import { type ShopResource } from '@/types/laravel';

defineProps<{
  shop: ShopResource
}>();

const authStore = useAuthStore();
const currentShopId = authStore.user?.current_shop?.shop_id;
</script>

<style scoped>
.shop-name {
  font-family: Inter, sans-serif;
}
</style>
